export interface IPagination{
  limit: number;
  page: number;
  pageCount: number;
  total: number;
  pageSizeOptions: number[];
}
